export enum SortType {
  asc = "asc",
  desc = "desc",
}
